import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Login } from '../common/components/Login'

export class LoginPage extends Component {
  render() {
    return (
      <Login
        loginPanelStyle={Styles.loginPanel}
        showTerms={true}>
      </Login>)
  }
}
const Styles = StyleSheet.create({
  loginPanel: {
    marginTop: 200,
    '@media (max-width: 767px)': {
      marginTop: 150,
    },
  },
})



// WEBPACK FOOTER //
// ./src/screens/LoginPage.js